/* eslint max-classes-per-file: 0 */

import {
  LkNotificationPage as Data,
  LkNotificationPageCollection as Collection,
} from '@/typings/api/NotificationPage'
import { LkPublicNotificationsPagesApi as Api } from '@/api/resources/public'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class LkPublicNotificationPagesTransformerParams extends TransformerParams {
  protected defaultParams = ['url'];
}

export class LkPublicNotificationPagesAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new LkPublicNotificationPagesTransformerParams();
}
